import { useCallback } from "react";
import { IconDeleteForever, IconEdit } from "@synthesis/shared-icons";
import { parseAsString, useQueryState } from "nuqs";

import { AdminGridTable, type RowMenuData } from "../../../components/admin-console/admin-grid-table";
import { DOCUMENT_TYPE_COLUMNS, MOCK_REFERENCE_DOCUMENT_TYPES, usePageStore, type ReferenceDocumentType } from "../reference-document-types-page.lib";

const searchParser = parseAsString.withDefault("").withOptions({ clearOnDefault: true });

/** Таблица типов документов: быстрый поиск из URL и меню строки (⋮ → «Изменить» / «Удалить»). */
export const DocumentTypesTable = () => {
  const store = usePageStore()!;
  const [search] = useQueryState("search", searchParser);

  const renderRowMenu = useCallback(
    (documentType: ReferenceDocumentType): RowMenuData => ({
      scheme: [
        {
          type: "ITEMS",
          elements: [
            { id: "edit", value: "edit", label: "Изменить", icon: <IconEdit className="size-4" aria-hidden /> },
            { id: "delete", value: "delete", label: "Удалить", icon: <IconDeleteForever className="size-4" aria-hidden /> },
          ],
        },
      ],
      state: {
        edit: () => store.setPopupAction({ type: "edit-document-type", documentType }),
        // TODO(FRONT-1390): удаление типа документа — после появления бэкенда.
        delete: () => undefined,
      },
    }),
    [store],
  );

  return (
    <AdminGridTable
      tableId="admin-reference-document-types-table"
      columns={DOCUMENT_TYPE_COLUMNS}
      rows={MOCK_REFERENCE_DOCUMENT_TYPES}
      quickFilterText={search ?? undefined}
      renderRowMenu={renderRowMenu}
      className="h-[32rem]"
    />
  );
};
